import type { ChangeEventHandler, MouseEventHandler } from 'react';
import React, { useCallback } from 'react';
import * as S from './styles';

type Props = {
  value: string | undefined;
  onChange: (value: string) => void;
  clearText: string;
  placeholder?: string;
  autoFocus?: boolean;
};

export const SecondarySearchField = ({
  value,
  onChange,
  placeholder,
  autoFocus,
  clearText,
}: Props) => {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    e => onChange(e.target.value),
    [onChange]
  );
  const handleClear = useCallback<MouseEventHandler<HTMLButtonElement>>(
    () => onChange(''),
    [onChange]
  );
  const canClear = value && value.length > 0;

  return (
    <S.SearchWrapper data-test="SecondarySearchField">
      <S.SearchInput
        value={value}
        type="search"
        onChange={handleChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />

      <S.ClearSearchButton
        onClick={handleClear}
        aria-label={clearText}
        disabled={!canClear}
      >
        {canClear ? (
          <S.ClearSearchIcon size={16} />
        ) : (
          <S.EmptySearchIcon size={16} />
        )}
      </S.ClearSearchButton>
    </S.SearchWrapper>
  );
};
